/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_UnisexInputs */

const en_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisex`)
};

const es_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisex`)
};

const fr_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisexe`)
};

const de_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisex`)
};

const ja_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユニセックス`)
};

const zh_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`男女通用`)
};

const ar_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للجنسين`)
};

const id_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uniseks`)
};

const it_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisex`)
};

const ru_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Унисекс`)
};

const pt_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unissex`)
};

const ko_val_unisex = /** @type {(inputs: Val_UnisexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공용`)
};

/**
* | output |
* | --- |
* | "Unisex" |
*
* @param {Val_UnisexInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_unisex = /** @type {((inputs?: Val_UnisexInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_UnisexInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_unisex(inputs)
	if (locale === "es") return es_val_unisex(inputs)
	if (locale === "fr") return fr_val_unisex(inputs)
	if (locale === "de") return de_val_unisex(inputs)
	if (locale === "ja") return ja_val_unisex(inputs)
	if (locale === "zh") return zh_val_unisex(inputs)
	if (locale === "ar") return ar_val_unisex(inputs)
	if (locale === "id") return id_val_unisex(inputs)
	if (locale === "it") return it_val_unisex(inputs)
	if (locale === "ru") return ru_val_unisex(inputs)
	if (locale === "pt") return pt_val_unisex(inputs)
	return ko_val_unisex(inputs)
});